/**
 * @generated SignedSource<<f46236eccd4a349e0840db6ea783d99d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bidId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "bidId",
    "variableName": "bidId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "documentType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dwollaStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessIdentityDocumentFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BusinessIdentityDocT",
        "kind": "LinkedField",
        "name": "businessIdentityDocTByBidId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessIdentityDocumentFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BusinessIdentityDocT",
        "kind": "LinkedField",
        "name": "businessIdentityDocTByBidId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "43dd6031d5b5ad93bf7f2cf84d1785f9",
    "id": null,
    "metadata": {},
    "name": "BusinessIdentityDocumentFetchQuery",
    "operationKind": "query",
    "text": "query BusinessIdentityDocumentFetchQuery(\n  $bidId: UUID!\n) {\n  businessIdentityDocTByBidId(bidId: $bidId) {\n    created\n    documentType\n    dwollaStatus\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "6854a188f36631bb6af049fd25acd6e4";

module.exports = node;
